var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorVenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.214,2.185h0c8.643,0,15.66,7.017,15.66,15.66h0c0,8.643-7.017,15.661-15.66,15.661H5.553v-15.661c0-8.643,7.017-15.66,15.66-15.66Z",
    transform: "translate(-6.405 20.227) rotate(-45)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.214,
    cy: 14.045,
    rx: 8.827,
    ry: 2.265
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.185,16.066c2.881.373,4.856,1.139,4.856,2.023,0,1.251-3.952,2.265-8.827,2.265s-8.827-1.014-8.827-2.265c0-.884,1.975-1.65,4.855-2.023"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25.596,20.054c2.656.39,4.446,1.125,4.446,1.967,0,1.251-3.952,2.265-8.827,2.265s-8.827-1.014-8.827-2.265c0-.842,1.792-1.577,4.45-1.967"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorVenue);
export default __webpack_public_path__ + "static/media/indoor-venue.e2f86c0261881a393b102f35878c7ced.svg";
export { ForwardRef as ReactComponent };